import React, { useEffect, useState } from "react";
import {
  FaAndroid,
  FaApple,
  FaBars,
  FaBuilding,
  FaComments,
  FaDownload,
  FaEnvelope,
  FaHome,
  FaStar,
  FaTimes,
  FaTruck,
  FaTruckMoving,
  FaWhatsapp,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import styled from "styled-components";
import logoImage from "../../assets/images/logo_r.png";
import logoEmpresas from "../../assets/images/trineo_empresas.png";
import {
  BREAKPOINTS,
  COLORS,
  FONTS,
  SHADOWS,
  SPACING,
} from "../../styles/variables";
import Button from "../Button/Button";

const HeaderWrapper = styled.header`
  padding: ${(props) => (props.$scrolled ? "6px" : "10px")} 0;
  background-color: ${(props) =>
    props.$scrolled
      ? COLORS.WHITE + "E8"
      : props.$dark
      ? "transparent"
      : COLORS.WHITE + "20"}; /* 20 = 12.5% opacidad en estado inicial */
  backdrop-filter: ${(props) =>
    props.$scrolled
      ? "blur(3px)"
      : "blur(1.5px)"}; /* Blur muy sutil en estado inicial */
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  transition: box-shadow 0.3s ease, padding 0.3s ease,
    background-color 0.3s ease, backdrop-filter 0.3s ease;
  ${({ $scrolled }) =>
    $scrolled &&
    `
    box-shadow: ${SHADOWS.MEDIUM};
  `}

  @media (min-width: ${BREAKPOINTS.TABLET}) {
    padding: ${(props) => (props.$scrolled ? "8px" : "12px")} 0;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 42px;
  position: relative;
  width: 100%;
  padding: 0 clamp(16px, 3vw, 32px);
`;

const Logo = styled.div`
  font-size: ${FONTS.SIZE_HEADING_3};
  font-weight: ${FONTS.WEIGHT_BOLD};
  color: ${COLORS.BLUE_MAIN};
  display: flex;
  align-items: center;
  text-decoration: none;

  &:hover {
    text-decoration: none;
    color: ${COLORS.BLUE_MAIN};
  }
`;

const LogoImage = styled.img`
  height: ${(props) => (props.$scrolled ? "34px" : "40px")};
  width: auto;
  transition: height 0.3s ease;

  @media (min-width: ${BREAKPOINTS.TABLET}) {
    height: ${(props) => (props.$scrolled ? "38px" : "46px")};
  }

  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    height: ${(props) => (props.$scrolled ? "32px" : "38px")};
  }
`;

const LogoPlaceholder = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${COLORS.BLUE_MAIN};
  margin-right: ${SPACING.SMALL};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 20px;
`;

const LogoText = styled.span`
  @media (max-width: 380px) {
    display: none;
  }
`;

const LogoTagline = styled.span`
  display: none; /* Nunca mostramos el tagline */
`;

const NavLinks = styled.nav`
  display: none;

  @media (min-width: ${BREAKPOINTS.TABLET}) {
    display: flex;
    align-items: center;
    gap: ${SPACING.MEDIUM};
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;

const NavLink = styled.a`
  color: ${(props) =>
    props.$dark && !props.$scrolled
      ? "rgba(255, 255, 255, 0.82)"
      : COLORS.BLACK_TEXT};
  font-weight: ${FONTS.WEIGHT_MEDIUM};
  text-decoration: none;
  transition: color 0.2s ease;
  position: relative;
  text-shadow: ${(props) =>
    props.$scrolled || props.$dark
      ? "none"
      : "0 0 5px rgba(255, 255, 255, 0.5)"};

  &:after {
    content: "";
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: ${(props) =>
      props.$dark && !props.$scrolled ? "#8fe9c0" : COLORS.BLUE_MAIN};
    transition: width 0.2s ease;
  }

  &:hover {
    color: ${(props) =>
      props.$dark && !props.$scrolled ? "#ffffff" : COLORS.BLUE_MAIN};

    &:after {
      width: 100%;
    }
  }
`;

const TransportistaLink = styled(NavLink)`
  color: #fbac02;
  font-weight: ${FONTS.WEIGHT_BOLD};
  display: flex;
  align-items: center;
  text-shadow: ${(props) =>
    props.$scrolled ? "none" : "0 0 5px rgba(255, 255, 255, 0.5)"};

  svg {
    margin-right: 5px;
    color: #fbac02;
  }

  &:after {
    background-color: #fbac02;
  }

  &:hover {
    color: #edb940;

    svg {
      color: #edb940;
    }
  }
`;

const EnterpriseLink = styled(NavLink)`
  display: flex;
  align-items: center;
  color: ${(props) =>
    props.$dark && !props.$scrolled ? "#ffffff" : COLORS.BLUE_MAIN};
  font-weight: ${FONTS.WEIGHT_BOLD};
  text-shadow: ${(props) =>
    props.$scrolled || props.$dark
      ? "none"
      : "0 0 5px rgba(255, 255, 255, 0.5)"};

  svg {
    margin-right: 5px;
    color: ${(props) =>
      props.$dark && !props.$scrolled ? "#ffffff" : COLORS.BLUE_MAIN};
  }

  &:after {
    background-color: ${(props) =>
      props.$dark && !props.$scrolled ? "#ffffff" : COLORS.BLUE_MAIN};
  }

  &:hover {
    color: ${(props) =>
      props.$dark && !props.$scrolled ? "#ffffff" : COLORS.BLUE_SECONDARY};

    svg {
      color: ${(props) =>
        props.$dark && !props.$scrolled ? "#ffffff" : COLORS.BLUE_SECONDARY};
    }
  }
`;

const ChannelButtons = styled.div`
  display: none;
  gap: ${SPACING.XSMALL};
  align-items: center;
  margin-left: auto;

  @media (min-width: ${BREAKPOINTS.DESKTOP}) {
    display: flex;
  }
`;

const HeaderCta = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 0 16px;
  border: 1px solid
    ${(props) =>
      props.$dark && !props.$scrolled
        ? "rgba(255, 255, 255, 0.28)"
        : "rgba(14, 51, 134, 0.14)"};
  border-radius: 999px;
  background: ${(props) =>
    props.$dark && !props.$scrolled ? "#ffffff" : COLORS.BLUE_MAIN};
  color: ${(props) =>
    props.$dark && !props.$scrolled ? "#07111f" : COLORS.WHITE};
  font-size: 14px;
  font-weight: 800;
  text-decoration: none;
  white-space: nowrap;
  box-shadow: ${(props) =>
    props.$dark && !props.$scrolled
      ? "0 14px 34px rgba(255, 255, 255, 0.12)"
      : "0 14px 28px rgba(14, 51, 134, 0.18)"};
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    color: ${(props) =>
      props.$dark && !props.$scrolled ? "#07111f" : COLORS.WHITE};
    transform: translateY(-1px);
    box-shadow: ${(props) =>
      props.$dark && !props.$scrolled
        ? "0 16px 38px rgba(255, 255, 255, 0.16)"
        : "0 16px 34px rgba(14, 51, 134, 0.24)"};
  }
`;

const HeaderSecondaryAction = styled(HeaderCta)`
  gap: 7px;
  border-color: ${(props) =>
    props.$dark && !props.$scrolled
      ? "rgba(255, 255, 255, 0.24)"
      : "rgba(14, 51, 134, 0.16)"};
  background: ${(props) =>
    props.$dark && !props.$scrolled
      ? "rgba(255, 255, 255, 0.08)"
      : "rgba(255, 255, 255, 0.72)"};
  color: ${(props) =>
    props.$dark && !props.$scrolled ? "#ffffff" : COLORS.BLUE_MAIN};
  box-shadow: none;

  &:hover {
    color: ${(props) =>
      props.$dark && !props.$scrolled ? "#07111f" : COLORS.BLUE_SECONDARY};
    background: ${COLORS.WHITE};
    box-shadow: 0 12px 28px rgba(14, 51, 134, 0.14);
  }
`;

const ButtonIcon = styled.span`
  display: flex;
  align-items: center;
  margin-right: ${SPACING.XSMALL};
`;

const StoreIconsSmall = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: 5px;
  font-size: 12px;
`;

const MobileMenuButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: ${(props) =>
    props.$dark && !props.$scrolled ? COLORS.WHITE : COLORS.BLUE_MAIN};
  cursor: pointer;
  display: flex;
  align-items: center;

  @media (min-width: ${BREAKPOINTS.TABLET}) {
    display: none;
  }
`;

const MobileMenu = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${COLORS.WHITE}E0;
  backdrop-filter: blur(5px);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  padding: ${SPACING.XSMALL};
  transform: translateX(${({ $isOpen }) => ($isOpen ? "0" : "100%")});
  transition: transform 0.3s ease;
  overflow-y: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
`;

const MobileMenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${SPACING.MEDIUM};
  width: 100%;
`;

const MobileMenuContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
`;

const MobileNavLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.XXSMALL};
  width: 100%;
`;

const MobileNavLink = styled.a`
  color: ${COLORS.BLACK_TEXT};
  font-size: ${FONTS.SIZE_BODY};
  font-weight: ${FONTS.WEIGHT_MEDIUM};
  text-decoration: none;
  padding-top: ${SPACING.XSMALL};
  padding-bottom: ${SPACING.XXSMALL};
  border-bottom: 1px solid ${COLORS.GREY_LIGHT};
  margin-bottom: ${SPACING.XXSMALL};
  display: flex;
  align-items: center;
  width: 100%;

  &:hover {
    color: ${COLORS.BLUE_MAIN};
  }

  svg {
    margin-right: 8px;
    font-size: 18px;
    color: ${COLORS.BLUE_MAIN};
  }
`;

const MobileNavDescription = styled.p`
  font-size: ${FONTS.SIZE_XSMALL};
  color: ${COLORS.BLACK_TEXT}99;
  margin-top: 2px;
  margin-bottom: ${SPACING.XXSMALL};
  line-height: 1.3;
`;

const MobileNavItem = styled.div`
  margin-bottom: ${SPACING.XSMALL};
  width: 100%;
`;

const MobileChannelButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.XSMALL};
  margin-top: ${SPACING.MEDIUM};
  width: 100%;
  padding: ${SPACING.SMALL} 0;

  @media (min-height: 600px) {
    margin-top: auto; /* Empuja los botones hacia abajo */
    border-top: 1px solid ${COLORS.GREY_LIGHT}50;
    padding-top: ${SPACING.MEDIUM};
  }
`;

const MobileChannelTitle = styled.p`
  font-size: ${FONTS.SIZE_SMALL};
  font-weight: ${FONTS.WEIGHT_SEMI_BOLD};
  margin-bottom: ${SPACING.XSMALL};
  margin-top: ${SPACING.SMALL};
  color: ${COLORS.BLACK_TEXT}99;
`;

const MobileTransportistaLink = styled(MobileNavLink)`
  color: #fbac02;
  font-weight: ${FONTS.WEIGHT_BOLD};
  display: flex;
  align-items: center;
  width: 100%;

  svg {
    margin-right: 8px;
    font-size: 18px;
    color: #fbac02;
  }
`;

const MobileEnterpriseLink = styled(MobileNavLink)`
  color: ${COLORS.BLUE_MAIN};
  font-weight: ${FONTS.WEIGHT_BOLD};

  svg {
    color: ${COLORS.BLUE_MAIN};
  }
`;

const LoginButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  color: ${COLORS.BLUE_MAIN};
  background-color: transparent;
  border: 1px solid ${COLORS.BLUE_MAIN};
  border-radius: 50%;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${COLORS.BLUE_MAIN}10;
    transform: translateY(-2px);
  }

  svg {
    font-size: 14px;
  }
`;

const ProfileButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  color: ${COLORS.WHITE};
  text-decoration: none;
  font-weight: ${FONTS.WEIGHT_MEDIUM};
  transition: background-color 0.2s ease, transform 0.2s ease;
  border-radius: 50%;
  background-color: ${COLORS.BLUE_MAIN};

  &:hover {
    background-color: ${COLORS.BLUE_DARK};
    transform: translateY(-2px);
  }
`;

const MobileLoginLink = styled(MobileNavLink)`
  color: ${COLORS.BLUE_MAIN};
  font-weight: ${FONTS.WEIGHT_SEMI_BOLD};

  svg {
    margin-right: 8px;
    font-size: 18px;
    color: ${COLORS.BLUE_MAIN};
  }
`;

const Header = ({ variant = "light", brand = "app" }) => {
  const isDark = variant === "dark";
  const isEnterprise = brand === "empresas";
  const logoSrc = brand === "empresas" ? logoEmpresas : logoImage;
  const homeHref = brand === "empresas" ? "/empresas" : "/";
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // Función para abrir WhatsApp
  const openWhatsApp = () => {
    // Número de WhatsApp con código de país
    const phoneNumber = "+56997647703";
    // Mensaje predefinido
    const message = encodeURIComponent(
      "Hola, necesito trasladar algo y me gustaría saber cómo Trineo puede ayudarme."
    );
    // URL de WhatsApp
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    window.open(whatsappUrl, "_blank");
  };

  // Función para descargar la app
  const downloadApp = () => {
    // Detectar sistema operativo para redireccionar a la tienda correspondiente
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      window.open(
        "https://play.google.com/store/apps/details?id=com.trineoapp.trienoapp&hl=es_419",
        "_blank"
      );
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.open(
        "https://apps.apple.com/cl/app/fletes-trineo/id6471224117",
        "_blank"
      );
    } else {
      // Si es Windows u otro dispositivo no móvil, redirigir a la página /app
      window.location.href = "/app";
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    // Verificar si el usuario está autenticado
    const checkAuth = () => {
      const token = localStorage.getItem("auth_token");
      setIsLoggedIn(!!token);
    };

    window.addEventListener("scroll", handleScroll);
    checkAuth(); // Verificar autenticación al cargar el componente

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Función para alternar el menú
  const toggleMenu = () => {
    const newMenuState = !isMenuOpen;
    setIsMenuOpen(newMenuState);

    // Prevenir el scroll de la página cuando el menú está abierto
    if (newMenuState) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  };

  // Limpiar el estilo de overflow cuando el componente se desmonta
  useEffect(() => {
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <>
      <HeaderWrapper $scrolled={scrolled} $dark={isDark}>
        <HeaderContainer>
          <Logo as="a" href={homeHref}>
            <LogoImage
              src={logoSrc}
              alt="Trineo Logo"
              $scrolled={scrolled}
            />
          </Logo>
          {isEnterprise ? (
            <>
              <NavLinks>
                <NavLink href="#capacidades" $scrolled={scrolled} $dark={isDark}>
                  Plataforma
                </NavLink>
                <NavLink href="#flujo-piloto" $scrolled={scrolled} $dark={isDark}>
                  Piloto
                </NavLink>
                <NavLink href="/contacto?tipo=piloto-b2b" $scrolled={scrolled} $dark={isDark}>
                  Contacto
                </NavLink>
              </NavLinks>
              <ChannelButtons>
                <HeaderSecondaryAction
                  href="/"
                  $scrolled={scrolled}
                  $dark={isDark}
                >
                  <FaHome /> Inicio
                </HeaderSecondaryAction>
                <HeaderCta
                  href="/contacto?tipo=piloto-b2b"
                  $scrolled={scrolled}
                  $dark={isDark}
                >
                  Solicitar piloto
                </HeaderCta>
              </ChannelButtons>
            </>
          ) : (
            <>
              <NavLinks>
                <NavLink href="/#caracteristicas" $scrolled={scrolled} $dark={isDark}>
                  Cómo funciona
                </NavLink>
                <NavLink href="/#categorias" $scrolled={scrolled} $dark={isDark}>
                  Vehículos
                </NavLink>
                <NavLink href="/contacto" $scrolled={scrolled} $dark={isDark}>
                  Contacto
                </NavLink>
                <TransportistaLink
                  href="/transportista"
                  $scrolled={scrolled}
                  $dark={isDark}
                >
                  <FaTruck /> Transportistas
                </TransportistaLink>
                <EnterpriseLink
                  href="/empresas"
                  $scrolled={scrolled}
                  $dark={isDark}
                >
                  <FaBuilding /> Empresas
                </EnterpriseLink>
              </NavLinks>
              <ChannelButtons>
              {/* Botón de login/perfil temporalmente oculto mientras OAuth está en verificación 
              {isLoggedIn ? (
                <ProfileButton to="/dashboard" title="Mi perfil">
                  <FaUser />
                </ProfileButton>
              ) : (
                <LoginButton to="/login" title="Ingresar">
                  <FaUser />
                </LoginButton>
              )}
              */}
              <Button
                variant="outline"
                size="small"
                style={{ borderColor: "#4CAF50", color: "#4CAF50" }}
                onClick={openWhatsApp}
              >
                <ButtonIcon>
                  <FaWhatsapp />
                </ButtonIcon>
                WhatsApp
              </Button>
              <Button variant="primary" size="small" onClick={downloadApp}>
                <ButtonIcon>
                  <FaDownload />
                </ButtonIcon>
                App
                <StoreIconsSmall>
                  <FaAndroid />
                  <FaApple />
                </StoreIconsSmall>
              </Button>
              </ChannelButtons>
            </>
          )}
          <MobileMenuButton onClick={toggleMenu} $dark={isDark} $scrolled={scrolled}>
            <FaBars />
          </MobileMenuButton>
        </HeaderContainer>
      </HeaderWrapper>

      <MobileMenu $isOpen={isMenuOpen}>
        <MobileMenuHeader>
          <Logo as="a" href={homeHref} onClick={toggleMenu}>
            <LogoImage src={logoSrc} alt="Trineo Logo" $scrolled={true} />
          </Logo>
          <MobileMenuButton onClick={toggleMenu}>
            <FaTimes />
          </MobileMenuButton>
        </MobileMenuHeader>

        <MobileMenuContent>
          {isEnterprise ? (
            <MobileNavLinks>
              <MobileNavItem>
                <MobileNavLink href="/empresas" onClick={toggleMenu}>
                  <FaHome /> Inicio empresas
                </MobileNavLink>
                <MobileNavDescription>
                  Vuelve al inicio de Trineo para Empresas
                </MobileNavDescription>
              </MobileNavItem>

              <MobileNavItem>
                <MobileEnterpriseLink href="#capacidades" onClick={toggleMenu}>
                  <FaBuilding /> Plataforma
                </MobileEnterpriseLink>
                <MobileNavDescription>
                  Capacidades que se validan durante el piloto
                </MobileNavDescription>
              </MobileNavItem>

              <MobileNavItem>
                <MobileNavLink href="#flujo-piloto" onClick={toggleMenu}>
                  <FaStar /> Flujo del piloto
                </MobileNavLink>
                <MobileNavDescription>
                  Implementación acompañada y decisión de escalamiento
                </MobileNavDescription>
              </MobileNavItem>

              <MobileNavItem>
                <MobileNavLink href="/" onClick={toggleMenu}>
                  <FaHome /> Inicio
                </MobileNavLink>
                <MobileNavDescription>
                  Ir a la landing principal de Trineo
                </MobileNavDescription>
              </MobileNavItem>

              <MobileNavItem>
                <MobileNavLink href="/contacto?tipo=piloto-b2b" onClick={toggleMenu}>
                  <FaEnvelope /> Contacto
                </MobileNavLink>
                <MobileNavDescription>
                  Conversemos sobre un piloto para tu operación
                </MobileNavDescription>
              </MobileNavItem>

              <MobileNavItem>
                <MobileNavLink href="/contacto?tipo=piloto-b2b" onClick={toggleMenu}>
                  <FaEnvelope /> Solicitar piloto
                </MobileNavLink>
                <MobileNavDescription>
                  Agenda una conversación para evaluar tu caso
                </MobileNavDescription>
              </MobileNavItem>
            </MobileNavLinks>
          ) : (
            <MobileNavLinks>
              <MobileNavItem>
                <MobileNavLink href="/" onClick={toggleMenu}>
                  <FaHome /> Inicio
                </MobileNavLink>
                <MobileNavDescription>
                  Vuelve a la página principal de Trineo
                </MobileNavDescription>
              </MobileNavItem>

            {/* Opción de login/perfil temporalmente oculta mientras OAuth está en verificación 
            {isLoggedIn ? (
              <MobileNavItem>
                <MobileLoginLink to="/dashboard" as={Link} onClick={toggleMenu}>
                  <FaUser /> Mi Perfil
                </MobileLoginLink>
                <MobileNavDescription>Accede a tu panel de control</MobileNavDescription>
              </MobileNavItem>
            ) : (
              <MobileNavItem>
                <MobileLoginLink to="/login" as={Link} onClick={toggleMenu}>
                  <FaUser /> Iniciar Sesión
                </MobileLoginLink>
                <MobileNavDescription>Accede a tu cuenta de Trineo</MobileNavDescription>
              </MobileNavItem>
            )}
            */}

            <MobileNavItem>
              <MobileEnterpriseLink href="/empresas" onClick={toggleMenu}>
                <FaBuilding /> Empresas y pilotos B2B
              </MobileEnterpriseLink>
              <MobileNavDescription>
                Pilotea Trineo Control Tower con operación real
              </MobileNavDescription>
            </MobileNavItem>

            <MobileNavItem>
              <MobileTransportistaLink
                href="/transportista"
                onClick={toggleMenu}
              >
                <FaTruck /> Transportistas
              </MobileTransportistaLink>
              <MobileNavDescription>
                Se parte de nuestra red de transportistas
              </MobileNavDescription>
            </MobileNavItem>

            <MobileNavItem>
              <MobileNavLink href="#caracteristicas" onClick={toggleMenu}>
                <FaStar /> ¿Por qué elegir Trineo?
              </MobileNavLink>
              <MobileNavDescription>
                Descubre nuestra plataforma
              </MobileNavDescription>
            </MobileNavItem>

            <MobileNavItem>
              <MobileNavLink href="#categorias" onClick={toggleMenu}>
                <FaTruckMoving /> Categorías de vehículos
              </MobileNavLink>
              <MobileNavDescription>
                Conoce las diferentes categorías para tus fletes
              </MobileNavDescription>
            </MobileNavItem>

            <MobileNavItem>
              <MobileNavLink href="#testimonios" onClick={toggleMenu}>
                <FaComments /> Experiencias con Trineo
              </MobileNavLink>
              <MobileNavDescription>
                Lee las experiencias de nuestros usuarios
              </MobileNavDescription>
            </MobileNavItem>

            <MobileNavItem>
              <MobileNavLink href="/contacto" onClick={toggleMenu}>
                <FaEnvelope /> Contacto
              </MobileNavLink>
              <MobileNavDescription>
                Buscanos en Redes Sociales
              </MobileNavDescription>
            </MobileNavItem>
            </MobileNavLinks>
          )}
        </MobileMenuContent>

        {isEnterprise ? (
          <MobileChannelButtons>
            <Button
              variant="primary"
              size="medium"
              onClick={() => {
                window.location.href = "/contacto?tipo=piloto-b2b";
              }}
            >
              Solicitar piloto B2B
            </Button>
          </MobileChannelButtons>
        ) : (
          <MobileChannelButtons>
            <Button
              variant="outline"
              size="medium"
              style={{ borderColor: "#4CAF50", color: "#4CAF50" }}
              onClick={openWhatsApp}
            >
              <FaWhatsapp style={{ marginRight: "8px" }} /> WhatsApp
            </Button>
            <Button variant="primary" size="medium" onClick={downloadApp}>
              <FaDownload style={{ marginRight: "8px" }} /> Descargar App
              <StoreIconsSmall style={{ marginLeft: "8px" }}>
                <FaAndroid />
                <FaApple />
              </StoreIconsSmall>
            </Button>
          </MobileChannelButtons>
        )}
      </MobileMenu>
    </>
  );
};

export default Header;
